// packages/kern/src/texte.ts — Blatt- und Editortexte im Kern (SPEC §3.14).
//
// KEIN DOM: außer `text-canvas.ts` darf keine Datei in `packages/kern/src`
// `document`, `window`, `navigator`, `fetch`, `localStorage` oder einen
// React-Import enthalten.
//
// Hier liegen NUR die Zeichenketten, die im Blatt oder in Layoutregeln
// vorkommen. Alles andere steht in `frontend/src/lib/texte.ts` (§5.9).
// `TB.stile` und `STYLES[k].label` müssen gleich sein — der Test in §7.3.1
// (`presets.test.ts`) prüft das.

export const TB = {
  blattAria: "Projektzeitplan",
  ferienLabel: "Schulferien",
  ferienFallback: "Ferien",
  quartal: (q: number) => q + ". Quartal",
  neuerEintrag: "Neuer Eintrag",
  dateiFallback: "Grobzeitplan",
  spurFallback: "Spur",
  neueSpur: "Neue Spur",
  stile: { solid: "Gefüllt", soft: "Gefüllt hell", outline: "Kontur", dashed: "Gestrichelt",
           meilen: "Meilenstein", grau: "Grau", akzent: "Akzent", ghost: "Nur Text" },
  vorlagen: { lilasp: "LILASp Standard", isek: "ISEK / Konzept (3 Phasen)", leer: "Leeres Blatt" },
} as const;
